import axiosInstance from '../utils/axiosInstance';

const API_URL = `${process.env.REACT_APP_API_URL}/api/clientportal/v1/`;

/**
 * Get paginated task list
 * @param {number} page - current page number
 * @param {number} limit - items per page
 */
const getTaskList = async (page = 1, limit = 25, search = '', status = '', sortBy = '', sortOrder = 'asc') => {
  const res = await axiosInstance.get(API_URL+"task", {
    params: {
      page,
      limit,
      search,
      status,
      sortBy,
      sortOrder,
    },
  });

  return res.data;
};


const updateTask = async (Threadid,data) => {
   
    const res = await axiosInstance.patch(API_URL +`chat/thread/${Threadid}/updateTask`,data,{
        headers: {
          'Content-Type': 'application/json',
        },})

    return res.data;

}




const TaskService = {
  getTaskList,updateTask
};

export default TaskService;
